import { FirebaseDynamicLinks } from 'firebase-dynamic-links'
import { getAnalytics } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { connectFirestoreEmulator, initializeFirestore } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions, httpsCallable } from 'firebase/functions'
import { Messaging, getMessaging, onMessage } from 'firebase/messaging'
import { getRemoteConfig } from 'firebase/remote-config'
import isUAWebView from 'is-ua-webview'

import { environment } from 'utils/constants'

const productionFirebaseConfig = {
  apiKey: 'AIzaSyA8o0uVXoyrIEt-J8Wvusw5eTz7DOUNbSU',
  authDomain: 'upswing-fitness.firebaseapp.com',
  projectId: 'upswing-fitness',
  storageBucket: 'upswing-fitness.appspot.com',
  messagingSenderId: '805902908636',
  appId: '1:805902908636:web:5c21c3e26d883521ae0819',
  measurementId: 'G-4ZZR5CWEFS',
}

const stagingFirebaseConfig = {
  apiKey: 'AIzaSyArGFX60w0PQMgAztlHQQdvGJhlBtJwGOU',
  authDomain: 'upswing-fitness-staging.firebaseapp.com',
  projectId: 'upswing-fitness-staging',
  storageBucket: 'upswing-fitness-staging.appspot.com',
  messagingSenderId: '77204901431',
  appId: '1:77204901431:web:f5f290dbc94fa804bc79b2',
  measurementId: 'G-NLJVLV42WB',
}

const developmentFirebaseConfig = {
  apiKey: 'AIzaSyA9hnhQsDgaBKHuzcyHN1uSaoJ4sjoNRy4',
  authDomain: 'upswing-fitness-develop.firebaseapp.com',
  projectId: 'upswing-fitness-develop',
  storageBucket: 'upswing-fitness-develop.appspot.com',
  messagingSenderId: '479946956872',
  appId: '1:479946956872:web:16303f70ba21c0d527787d',
  measurementId: 'G-5ERDZWX2W3',
}

let firebaseConfig

if (environment.isDev) {
  firebaseConfig = developmentFirebaseConfig
} else if (environment.isStaging) {
  firebaseConfig = stagingFirebaseConfig
} else {
  firebaseConfig = productionFirebaseConfig
}

export const firebaseApp = initializeApp(firebaseConfig)
export const db = initializeFirestore(firebaseApp, { experimentalForceLongPolling: true })
export const functions = getFunctions(firebaseApp)
export const remoteConfig = getRemoteConfig(firebaseApp)

// eslint-disable-next-line import/no-mutable-exports
export let webMessaging: Messaging | null = null
if (!isUAWebView) {
  webMessaging = getMessaging(firebaseApp)
}

if (webMessaging && remoteConfig) {
  onMessage(remoteConfig, (payload) => {
    console.log('FCM PAYLOAD: ', payload)
  })
}

// Analytics is only supported on web platforms
export const analytics = getAnalytics(firebaseApp)
export const auth = getAuth(firebaseApp)

if (environment.isLocal) {
  connectFunctionsEmulator(functions, 'localhost', 5001)
  connectAuthEmulator(auth, 'http://localhost:9099')
  connectFirestoreEmulator(db, 'localhost', 8080)
}

export const getFileUploadSignature = httpsCallable<{ [key: string]: string }, string>(
  functions,
  'getFileUploadSignature',
)

export const functionCall = httpsCallable

export const firebaseDynamicLinks = new FirebaseDynamicLinks(firebaseConfig.apiKey)
